module.exports = __webpack_public_path__ + "img/avatar-2.34613ee5.png";